import React from "react";
import { RideSkeleton } from "@rimac-seguros/ride-system-components";
import { CustomSliderRange } from "@/components/molecules/CustomSliderRange";

export const RepaymentPercentage = ({
  list,
  defaultValue,
  initialDefault,
  loading,
  onSelected,
  isGreatterValue,
}) => {
  return (
    <>
      <div className="relative border-b py-ride-gl-spacing-4xlarge border-ride-sys-color-border-default">
        <h2 className="flex items-center ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge gap-ride-gl-spacing-large lg:ride-sys-text-title-2xlarge-default lg:mb-ride-gl-spacing-4xlarge">
          Elige tu porcentaje de devolución
        </h2>
        <div>
          {!loading && list?.length > 0 ? (
            <CustomSliderRange
              list={list}
              defaultValue={defaultValue}
              initialDefault={initialDefault}
              onSelect={onSelected}
              isGreatterValue={isGreatterValue}
            />
          ) : (
            <RideSkeleton type="rectangle" height={48} width="100%" />
          )}
        </div>
      </div>
    </>
  );
};
